<template>
  <div class="card">
    <div class="card-header">
<!-- Per tornare indietro -->
<a href="#" @click="goBack" class="icon-link">
  <span class="material-icons">chevron_left</span>
</a>
      <span>Fusco Fit</span>
<!-- Per andare alla home -->
<a href="#/user" class="icon-link">
  <span class="material-icons">home</span>
</a>
    </div>
    <!-- Immagine centrata -->
    <div class="card-image">
  <img src="https://www.metodofusco.it/media/VIDEOCALL.png" alt="Descrizione dell'immagine">
    </div>
    <div class="card-content">
      <!-- Titolo e indirizzo allineati a sinistra -->
      <h2>COSA FACCIAMO PER TE</h2>
      <!-- Descrizione allineata a sinistra -->
      <div class="description">
        <p>Sei qui perché vuoi fare un passo importante verso una vita più sana e felice. Immagino che tu stia cercando qualcosa di più di un semplice piano alimentare. Qui da noi, non vogliamo solo dirti cosa mangiare, ma capire davvero chi sei e cosa hai bisogno di raggiungere il tuo massimo potenziale.</p>
      </div>
      <div class="card-image">
  <img src="https://www.metodofusco.it/media/VIDEOCALL2.png" alt="Descrizione dell'immagine">
    </div>
        <div class="description">
        <p>Iniziamo con un colloquio approfondito. Parliamo di te, delle tue abitudini, del tuo stile di vita e di come ti senti. Non si tratta solo di cibo, ma di comprendere te stesso a un livello più profondo.</p>
        <p>Poi passiamo agli obiettivi. Cosa vuoi ottenere? Perdere peso? Aumentare l’energia? Gestire una condizione specifica? Insieme, delineeremo chiaramente cosa stai cercando di raggiungere.</p>
        <p>Il piano alimentare che creiamo non è uno stampo universale. È su misura per te, tenendo conto delle tue preferenze e delle tue esigenze nutrizionali individuali. Non vogliamo solo darti cibo, ma integrare abitudini che dureranno a lungo.</p>
      </div>
    <h2>QUELLO CHE TI DAREMO</h2>
    <div class="card-image">
  <img src="https://www.metodofusco.it/media/VIDEOCALL1.png" alt="Descrizione dell'immagine">
    </div>
    <div class="description">
        <p>Ti daremo tanti consigli pratici dalla spesa alla cucina, vogliamo rendere il tuo nuovo stile di vita sostenibile e pratico.
Non vogliamo complicarti la vita, vogliamo facilitarti il cammino verso il benessere.</p>
<p>E poi c’è il lato emotivo. Sappiamo quanto sia difficile mantenere la motivazione. È per questo che offriamo sostegno emotivo.</p>
  <p>Abbiamo tutti i mezzi per aiutarti a superare i momenti difficili, perché la tua motivazione è una chiave fondamentale per il successo.</p>
    <p>Quindi, se sei pronto per un cambiamento reale, se vuoi qualcosa di più di una dieta, sei nel posto giusto. Contattaci e iniziamo questo viaggio insieme.</p>
      </div>
    </div>
  </div>
    <div class="card-actions">
      <p>Video call con nutrizionista 30 min</p>
      <a href="https://www.fusco.fit/?add-to-cart=51203" class="btn-call" role="button">
        <span class="material-icons">add_circle_outline</span>
        Acquista&nbsp;<del>50€</del>&nbsp;<span><strong>30€</strong></span>
      </a>
    </div>
</template>


<script>

export default {
  data() {
    return {
      // Aggiungi una proprietà per tenere traccia della chiave di refresh.
    };
  },
  methods: {

    goBack() {
      this.$router.go(-1); // Naviga alla vista precedente
    },
    
  },

};
</script>

